import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, languageNames } from './translations';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Try to get saved language from localStorage
        const saved = localStorage.getItem('shiguangji-language');
        if (saved && translations[saved]) {
            return saved;
        }
        // Default to Simplified Chinese
        return 'zh-CN';
    });

    useEffect(() => {
        // Save to localStorage when language changes
        localStorage.setItem('shiguangji-language', language);
    }, [language]);

    const t = (section, key) => {
        return translations[language]?.[section]?.[key] || key;
    };

    const getFullTranslation = (section) => {
        return translations[language]?.[section] || {};
    };

    const changeLanguage = (lang) => {
        if (translations[lang]) {
            setLanguage(lang);
        }
    };

    const value = {
        language,
        setLanguage: changeLanguage,
        t,
        getFullTranslation,
        languageNames,
        availableLanguages: Object.keys(translations),
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};
